enum ResponsibleType {
  PERSON = 'PERSON',
  PROJECT = 'PROJECT',
}

export default ResponsibleType;
